import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AngularFirestore } from '@angular/fire/firestore';
import { MatDialog } from '@angular/material/dialog';
import { Iaddress, Users } from 'my-lib-sanfelici/my-lib-sanfelici';
import { Contatti } from 'my-lib-sanfelici/my-lib-sanfelici';
import { UsersService } from 'my-lib-sanfelici';
import { ContattiService } from 'my-lib-sanfelici';
import { NewMapsDialogViewComponent } from '../../new-maps/new-maps-dialog-view/new-maps-dialog-view.component';

@Component({
  selector: 'app-contatti-edit',
  templateUrl: './contatti-edit.component.html',
  styleUrls: ['./contatti-edit.component.scss']
})
export class ContattiEditComponent implements OnInit {
  address: Iaddress;
  contatto: Contatti;
  id: string;
  user: Users;
  constructor(
    public dialog: MatDialog,
    private router: Router,
    private usersservice: UsersService,
    private contattiservice: ContattiService,
    private db: AngularFirestore,
    private route: ActivatedRoute) { }
    openDialog(): void {
      const dialogRef = this.dialog.open(NewMapsDialogViewComponent, {
      });

      dialogRef.afterClosed().subscribe(result => {
        this.address = result;
        this.contatto.address = this.address;
      });
    }
              onSubmit() {
                this.user.contatto = this.contatto;
                this.usersservice.update(this.user).then(() => {
                  this.router.navigate(['/myuser', 'contatti', 'details', this.id]);
                 });

                   }
  ngOnInit() {
    this.id = this.route.snapshot.params.id;

    this.usersservice.details(this.id)
    .subscribe(u =>
      {
        if(u){
          this.user = u;
          if(this.user.contatto)
          {} else {
            this.user.contatto={nome:null,cognome:null,fiscalcode:null,phone:null}
          }
          this.contatto = this.user.contatto;
        } 
        
      });


  }

}
